import { Box, Button, CircularProgress, } from '@mui/material';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logout_dispatch } from '../../../redux/auth/auth.actions';
import { get_auth_process_states } from '../../../redux/auth/auth.selectors';
import UserGuideButton from '../../UserGuide/components/UserGuideButton';

const UserData = ({ employee_id, analyst_name, designation }) => {
  const dispatch = useDispatch();

  const { auth_process_loading } = useSelector(get_auth_process_states);
  const handleLogout = () => {
    dispatch(logout_dispatch());
  };

  return (
    <div className="w-full mx-auto border bg-white p-4 flex justify-between items-center">
      <div>
        <img
          className="cursor-pointer h-[5rem] ml-2 "
          src="/ripikremovedbg.png"
          alt="ripik-logo"
        />
        {/* <div className='ps-2 text-gray-900 text-2xl'>
          QC Analyst Portal
        </div> */}
      </div>
      <div className="">
        <div className="flex justify-between items-center gap-4">
          {employee_id === "." ? null : <div className="uppercase text-sm text-indigo-500 font-semibold">
            Employee ID: {employee_id}
          </div>}
          <div className="uppercase text-sm font-semibold">
            <Button className={auth_process_loading ? "text-gray-500" : "hover:text-red-500 hover:cursor-pointer"} variant='outlined' color='error' onClick={handleLogout} >
              <Box>
                Logout
              </Box>
              {
                auth_process_loading && <CircularProgress size={20} color="inherit" />
              }
            </Button>
          </div>
        </div>
        <div className="flex justify-between items-center mt-4">
          <p className="text-2xl text-center font-extrabold text-gray-900">
            {analyst_name}
          </p>
          <UserGuideButton />
        </div>
        {/* <p className="text-base text-gray-500">
          Designation: {designation}
        </p> */}
      </div>
    </div>
  );
};

export default UserData;
